import { CSSProperties, useTheme } from 'styled-components';

export interface CheckMarkIconProps {
  color?: CSSProperties['fill'];
  className?: string;
}

export const CheckMarkIcon: React.FC<CheckMarkIconProps> = ({ color, className }) => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M5.6 10.6L1.4 6.4L0 7.8L5.6 13.4L17.6 1.4L16.2 0L5.6 10.6Z" fill={color ?? theme.main.deepBlue} />
    </svg>
  );
};
